import React from "react";
import { FormattedMessage } from "react-intl";
import { margins } from "style";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import { OrganizationCustomerPortalVersionSelector } from "components/Organizations";

/**
 * OrganizationCustomerPortalVersion
 */
const OrganizationCustomerPortalVersion = (props) => (
  <>
    <Header marginSize={margins.normal}>
      <H3>
        <FormattedMessage id="Organizations.OrganizationCustomerPortalVersion.Header.Title" />
      </H3>
    </Header>
    <OrganizationCustomerPortalVersionSelector disabled {...props} />
  </>
);

export default OrganizationCustomerPortalVersion;
